import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartIcon from '../../icons/cart';
import AddToCart from '../AddToCart';
import ReadMore from '../ReadMore';

export default function SeriesThree() {

  document.title = `Special Editions | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Special Editions from Hanuman Editions.`);


  return (
    <div className='newPageContainer'>

      <div className='booksPage'>
        <h5>Special Editions</h5>


        <div className='gridThree'>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/1969-eileen-myles' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/1969_Side_v2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>1969</div>
                <div className='nb-author'>Eileen Myles</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798995641001'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/by-surprise-henri-michaux' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/Michaux_Side_v2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>

                <div className='nb-title'>By Surprise</div>
                <div className='nb-author'>Henri Michaux</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416581'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/on-the-lords-prayer-simone-weil' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/Weil_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>On the Lord's Prayer</div>
                <div className='nb-author'>Simone Weil</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416598'} />
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  )
}